import cn from "classnames";

import { SaleIcon } from "@/components/icons/sale.icon";
import { RichText } from "@/components/richText/richText.component";

import { portableTextToPlain } from "@/utils/portableText.util";

import type { RichText as SanityRichText } from "@/sanity.types";

export const PromoBadge = ({
  label,
  className,
  iconSize = 32,
  testId = "promo-badge",
  centered = false,
}: PromoBadgeProps) => {
  const text = portableTextToPlain(label);
  if (!text) return null;

  if (centered) {
    const iconHeight = Math.round(iconSize * (17 / 16));
    return (
      <div
        className={cn("text-primary flex justify-center", className)}
        data-testid={testId}>
        <div className="relative max-w-[20rem] text-center md:max-w-full [&_span.block]:w-auto">
          <SaleIcon
            width={iconSize}
            height={iconHeight}
            aria-hidden
            className="absolute right-full -left-2 mr-2 shrink-0 md:left-auto"
          />
          <RichText>{label}</RichText>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn("text-success flex gap-2", className)}
      data-testid={testId}>
      <SaleIcon width={iconSize} aria-hidden className="shrink-0" />
      <div className="flex-1">
        <RichText>{label}</RichText>
      </div>
    </div>
  );
};

type PromoBadgeProps = {
  label?: SanityRichText | null;
  className?: string;
  iconSize?: number;
  testId?: string;
  centered?: boolean;
};
